import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardRenewal from "../../../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Color from "../../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomButton from "../../../../components/CustomButton";
import AuthManager from "../../../../../utils/AuthManager";
import * as selector from "../../../../../common/selectors";
import * as onlineRenewalSelector from "../../../../../common/selectors/onlineRenewal";
import * as renewalAction from "../../../../../common/actions/onlineRenewal";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

class CheckRewability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      checkRenewabilityAction: false,
      redirecting:false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await AuthManager.retrievePolicyNo().then((value) => {
      if (value !== null) {
        console.log(value);
        this.setState({ localPolicyNo: value });
      } else {
        const { history } = this.props;
        history.push("/OnlineRenewal");
      }
    });
  }

  componentDidUpdate = () => {
    const {
      checkRenewabilityData,
      checkRenewabilityLoading,
      checkRenewabilityStatus,
      renewalPayNowData,
    } = this.props;

    if (
      this.state.checkRenewabilityAction === true &&
      checkRenewabilityData !== null &&
      checkRenewabilityLoading === false &&
      checkRenewabilityStatus === true
    ) {
      const renewable = onlineRenewalSelector.checkRenewabilityDataRenewable(
        checkRenewabilityData
      );
      const failedStatus = onlineRenewalSelector.checkRenewabilityDataRenewabilityStatus(
        checkRenewabilityData
      );
      const isTiqHome = onlineRenewalSelector.checkRenewabilityDataIsTiqHome(
        checkRenewabilityData
      );
      const redirectUrl = onlineRenewalSelector.checkRenewabilityDataRedirectUrl(
        checkRenewabilityData
      );
      
      //console.log("failedStatus", failedStatus);
      const { history } = this.props;
      if (renewable === true) {
        history.push("/PolicyInfo");
      } else if (failedStatus === 4) {
        if(redirectUrl !== null){
          this.onClickRepurchase();
        }else{
          history.push("/RenewalUnsuccessful");
        }
        
      } else {
        history.push("/RenewalUnsuccessful");
      }
      this.setState({ checkRenewabilityAction: false });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    // AuthManager.removePolicyNo();
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onClickReEnter = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Re Enter Policy Number'
    });
    const { history } = this.props;
    history.push("/OnlineRenewal");
    
  };

  onClickCheck = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Confirm & Check Renewability'
    });
    const { history, checkRenewability, renewalPayNow } = this.props;
    let Renewal = {
      Renewal: {
        PolicyNumber: this.state.localPolicyNo,
      },
    };

    checkRenewability(Renewal);
    //renewalPayNow("$150.00", "TC0008340", "S0178141C", "PA000363", false);
    this.setState({ checkRenewabilityAction: true });
    //history.push("/PolicyInfo");
    // history.push("/RenewalUnsuccessful")
  };

  onClickHere = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Back To Login'
    });
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  onClickRepurchase = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Repurchase'
    });
    const { checkRenewabilityData } = this.props;
    // const tiqHome = onlineRenewalSelector.checkRenewabilityDataTiqHome(
    //   checkRenewabilityData
    // );
    // const tiqHomeUrl = onlineRenewalSelector.checkRenewabilityDataTiqHomeUrl(
    //   checkRenewabilityData
    // );
    const isTiqHome = onlineRenewalSelector.checkRenewabilityDataIsTiqHome(
      checkRenewabilityData
    );
    const redirectUrl = onlineRenewalSelector.checkRenewabilityDataRedirectUrl(
      checkRenewabilityData
    );
    

    // if (tiqHome !== null && tiqHomeUrl !== null) {
    //   let form = document.createElement("form");
    //   form.setAttribute("method", "post");
    //   form.setAttribute("action", tiqHomeUrl);
    //   let field = [
    //     { name: "PDPADMail", value: tiqHome.PDPADMail },
    //     { name: "PDPAEmail", value: tiqHome.PDPAEmail },
    //     { name: "APIName", value: tiqHome.APIName },
    //     { name: "PDPAPhone", value: tiqHome.PDPAPhone },
    //     { name: "PDPASMS", value: tiqHome.PDPASMS },
    //     {
    //       name: "RenewalStartDate",
    //       value: tiqHome.RenewalStartDate,

    //     },
    //     { name: "dob", value: tiqHome.dob },
    //     { name: "email", value: tiqHome.email },
    //     { name: "hdbRoomType", value: tiqHome.hdbRoomType },
    //     { name: "mailing_block", value: tiqHome.mailing_block },
    //     { name: "mailing_building", value: tiqHome.mailing_building },
    //     { name: "mailing_postal", value: tiqHome.mailing_postal },
    //     { name: "mailing_street", value: tiqHome.mailing_street },
    //     { name: "mailing_unit", value: tiqHome.mailing_unit },
    //     { name: "mobile", value: tiqHome.mobile },
    //     { name: "name", value: tiqHome.name },
    //     { name: "nric", value: tiqHome.nric },
    //     { name: "property_block", value: tiqHome.property_block },
    //     { name: "property_building", value: tiqHome.property_building },
    //     { name: "property_postal", value: tiqHome.property_postal },
    //     { name: "property_street", value: tiqHome.property_street },
    //     { name: "property_unit", value: tiqHome.property_unit },
    //   ];
    //   for (let i = 0; i < field.length; i++) {
    //     let hf = document.createElement("input");
    //     hf.setAttribute("type", "hidden");
    //     hf.setAttribute("name", field[i].name);
    //     hf.setAttribute("value", field[i].value);
    //     form.appendChild(hf);
    //   }
    //   document.body.appendChild(form);
    //   form.submit();
    // }
    // if (isTiqHome === true) {
    //   // const { renewalTiqHome } = this.props;
    //   // let Renewal = {
    //   //   Renewal: {
    //   //     PolicyNumber: this.state.localPolicyNo,
    //   //   },
    //   // };
    //   // renewalTiqHome(Renewal);
    //   window.location.href =
    //     process.env.REACT_APP_BASE_API_URL +
    //     "Payment/RenewalTiqHome?policyNumber=" +
    //     this.state.localPolicyNo;
    // }
    window.location.href =redirectUrl;
  };

  renderChildren = () => {
    const { classes, location, checkRenewabilityLoading } = this.props;
    //const {policyNo} = location.state;
    return (
      <Grid container direction={"column"} spacing={2}>
        {checkRenewabilityLoading ? <LoadingOverlay loading={true} /> : false}
        <Grid item>
          <CustomText
            design={classes.renewNowTextStyle}
            style={{ color: "#2c3034" }}
          >
            Renew Now
          </CustomText>
        </Grid>
        <Grid item>
          <CustomTextInput
            title={"Please confirm the Policy Number"}
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth={true}
            value={this.state.localPolicyNo}
            disabled={true}
          />
        </Grid>

        <Grid item>
          <CustomButton
            title={"Confirm & Check Renewability"}
            design={classes.checkButtonStyle}
            textstyle={classes.buttonTextStyle}
            onClick={this.onClickCheck}
            id={"clickConfirmButton"}
          />
        </Grid>

        <Grid item>
          <CustomButton
            title={"Re-Enter Policy Number"}
            design={classes.reEnterButtonStyle}
            textstyle={classes.buttonTextStyle}
            onClick={this.onClickReEnter}
          />
        </Grid>

        <Grid item>
          <CustomText design={classes.bottomTextStyle} component="div">
            For customers with an Online Account, you may log in{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={this.onClickHere}
            >
              here
            </CustomText>{" "}
            to use your eWallet credits.
          </CustomText>
        </Grid>
      </Grid>
    );
  };

  render() {
    const { classes, checkRenewabilityLoading, } = this.props;
    const { height, width,redirecting } = this.state;
    const {
      checkRenewabilityData,
      checkRenewabilityStatus,
      renewalPayNowData,
    } = this.props;

    return (
      <div className={classes.root}>
        <Helmet>
          <title>Renewal</title>
        </Helmet>
        <CustomBoardRenewal
          children={this.renderChildren()}
          height={height}
          width={width}
        />
        {checkRenewabilityLoading ? <LoadingOverlay loading={true} /> : false}
        {redirecting ? <LoadingOverlay loading={true} /> : false}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  checkButtonStyle: {
    height: 40,
    fullWidth: true,
    marginTop: 10,
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  reEnterButtonStyle: {
    fullWidth: true,
    height: 40,
    marginBottom: 10,
    backgroundColor: "white",
    borderColor: Color.primaryColor,
    color: Color.primaryColor,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      borderColor: "transparent",
    },
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  errorTextStyle: {
    color: "red",
  },
});

function mapStateToProps(state) {
  return {
    checkRenewabilityData: selector.checkRenewabilityData(state),
    checkRenewabilityLoading: selector.checkRenewabilityLoading(state),
    checkRenewabilityStatus: selector.checkRenewabilityStatus(state),
    renewalPayNowData: selector.renewalPayNowData(state),
    renewalPayNowLoading: selector.renewalPayNowLoading(state),
    renewalPayNowStatus: selector.renewalPayNowStatus(state),
    renewalTiqHomeData: selector.renewalTiqHomeData(state),
    renewalTiqHomeLoading: selector.renewalTiqHomeLoading(state),
    renewalTiqHomeStatus: selector.renewalTiqHomeStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    checkRenewability: (submitData) =>
      dispatch(renewalAction.checkRenewability(submitData)),
    renewalPayNow: (premium, orderNo, nric, policyNo, isRecurring) =>
      dispatch(
        renewalAction.renewalPayNow(
          premium,
          orderNo,
          nric,
          policyNo,
          isRecurring
        )
      ),
    renewalTiqHome: (submitData) =>
      dispatch(renewalAction.renewalTiqHome(submitData)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(CheckRewability)));
